import base from "./modules/base.config";
import prd from "./modules/production.config";
import dev from "./modules/development.config";
import prd_hit from "./modules/hit/production.config";
import prd_tqs from "./modules/tqs/production.config";
import prd_shk from "./modules/shk/production.config";
import prd_cstgo from "./modules/cstgo/production.config";


const config = {
    ... base,
    ... (process.env.NODE_ENV == "development" ? dev :
        window.gconf.profile == "hit"? prd_hit:
        window.gconf.profile == "tqs"? prd_tqs:
            window.gconf.profile == "shk"? prd_shk:
            window.gconf.profile == "cstgo"? prd_cstgo:
                prd
    ),
};




export default config;